const initialClientState = {
  fetching: false,
  fetched: false,
  nbResult: 0,
  pageSize: 10,
  paginationPage: 1,
  year: null,
  years: [],
  items: [],
  filter: {
    label: "",
    budgetState: [],
    pourcentage: "",
    color: "",
    budgetWarning: []
  },
  error: null
};

export const getClientsListReducer = (state = initialClientState, action) => {
  switch (action.type) {
    case "INIT_CLIENT_LIST": {
      return initialClientState;
    }
    case "SET_CLIENTS_LIST_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_CLIENTS_LIST_PAGE_SIZE": {
      return {
        ...state,
        pageSize: action.pageSize,
        paginationPage: 1
      };
    }
    case "SET_CLIENT_BUDGET_FILTER_STATE": {
      return {
        ...state,
        filter: { ...state.filter, budgetState: action.budgetState }
      };
    }
    case "SET_CLIENTS_LIST_BUDGET_YEAR": {
      return {
        ...state,
        year: action.year
      };
    }
    case "SET_CLIENTS_LIST_FILTER_TITLE": {
      return {
        ...state,
        filter: { ...state.filter, label: action.title },
        paginationPage: 1
      };
    }
    case "SET_CLIENTS_BUDGET_WARNING": {
      return {
        ...state,
        filter: { ...state.filter, budgetWarning: action.warning }
      };
    }
    case "FETCH_CLIENT_LIST_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_CLIENT_LIST_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        nbResult: action.payload.data.nbResult,
        items: action.payload.data.data
      };
    }
    case "FETCH_CLIENT_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "FETCH_BUDGET_YEARS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_BUDGET_YEARS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        years: action.payload.data.data
      };
    }
    case "FETCH_BUDGET_YEARS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};

const initialClientEntitySettingState = {
  loading: false,
  error: null
};

export const clientEntitySettingReducer = (
  state = initialClientEntitySettingState,
  action
) => {
  switch (action.type) {
    case "INIT_CLIENT_ENTITY_SETTING": {
      return {
        ...state,
        ...initialClientEntitySettingState
      };
    }
    case "SAVE_CLIENT_ENTITY_SETTING_PENDING": {
      return {
        ...state,
        clientEntitySetting: { ...state, loading: true }
      };
    }
    case "SAVE_CLIENT_ENTITY_SETTING_FULFILLED": {
      return {
        ...state,
        clientEntitySetting: { ...state, loading: false }
      };
    }
    case "SAVE_CLIENT_ENTITY_SETTING_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        error,
        clientEntitySetting: { ...state, loading: false }
      };
    }
    default:
      return state;
  }
};

const initialImportClientsBudgetState = {
  fetching: false,
  fetched: false,
  error: null,
  importAttachment: null,
  isImportModalVisible: false,
  importedYear: new Date().getFullYear() + 1
};

export const importClientsBudgetReducer = (
  state = initialImportClientsBudgetState,
  action
) => {
  switch (action.type) {
    case "INIT_IMPORT_CLIENTS_BUDGET": {
      return initialImportClientsBudgetState;
    }
    case "IMPORT_CLIENTS_BUDGET_PENDING": {
      return { ...state, fetching: true };
    }
    case "IMPORT_CLIENTS_BUDGET_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null
      };
    }
    case "IMPORT_CLIENTS_BUDGET_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_IMPORT_CLIENTS_BUDGET_MODAL": {
      return {
        ...state,
        isImportModalVisible: action.visible
      };
    }
    case "SET_IMPORT_CLIENTS_BUDGET_ATTACHMENT": {
      return { ...state, importAttachment: action.importAttachment };
    }
    case "SET_CLIENTS_BUDGET_IMPORTED_YEAR": {
      return { ...state, importedYear: action.year };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/client.js